export default __webpack_public_path__ + "static/media/ind3.4334c40c.svg";